import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { TimeCardsState, TimeCardsStore } from './time-cards.store';
import { AppStateQuery } from 'projects/desktop/src/app/data/app-state.query';
import { map } from 'rxjs/operators';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class TimeCardsQuery extends QueryEntity<TimeCardsState> {
    trackWorkTime = this.appStateQuery
        .select(state => state.currentUser)
        .pipe(
            map(user => user.trackWorkTime)
        );
    todayCards = this.select(state => state.ui.todayCards);
    firstTimeCard = this.select(state => state.ui.firstTimeCard);
    lastTimeCard = this.select(state => state.ui.lastTimeCard);
    punchedIn$ = this.select(state => state.punchedIn);
    todayTotalTime$ = this.select(state => state.ui.todayTotalTime);
    weekTotalTime$ = this.select(state => state.ui.weekTotalTime);
    ppTotalTime$ = this.select(state => state.ui.ppTotalTime);
    chosenProject$ = this.select(state => state.ui.chosenProject);

    breakType$ = this.lastTimeCard.pipe(
        map(lastTimeCard => {
            if (lastTimeCard && !lastTimeCard.finishTime) {
                return lastTimeCard ? lastTimeCard.type : null
            }
            return 'WORK';
        })
    )
    breakTime$ = this.select(state => state.ui.breakTime);
    breakTimeString$ = this.breakTime$.pipe(map(seconds => moment.utc(seconds * 1000).format('HH:mm:ss')))


    constructor(
        protected store: TimeCardsStore,
        protected appStateQuery: AppStateQuery
    ) {
        super(store);
    }
}